import { render, staticRenderFns } from "./RedoPieceFields.vue?vue&type=template&id=6536168f&scoped=true"
import script from "./RedoPieceFields.vue?vue&type=script&lang=js"
export * from "./RedoPieceFields.vue?vue&type=script&lang=js"
import style0 from "./RedoPieceFields.vue?vue&type=style&index=0&id=6536168f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6536168f",
  null
  
)

export default component.exports